
     
    import { Options, Vue } from "vue-class-component";   
    import { ref } from 'vue';
    import PatrimonioService from   "@/service/v1/sigap/PatrimonioService"  
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "FileSiga",
        components: {   CardRh },  
        emits: ['siga-lote-cadastro'],   
    }) 
    export default class FileSiga extends Vue { 

        @authStore.Getter
		public perfis!: any  
 
        public service = new PatrimonioService();  
 
        private arquivoReferencia = ref<FileList | null>(null);
        public arquivo: any = ''; 
        public processando = false;
         
        handleFileUpload() {  
            this.arquivo =  ( this.arquivoReferencia as any ).files![0]; 
        }
 
        public salvar() {  
            this.processando = true;
            const dados = new FormData(); 
            if (this.arquivo   ) {
                dados.append('File', this.arquivo); 
            } 
            this.service.ProccesaPatrimonioSigaLote(   dados  )
            .then(response => {
                this.$emit("siga-lote-cadastro", null);   
                this.processando = false; 
            })
            .catch(error => {  
                this.processando = false; 
                console.log(error);
            })
            .finally( () => {
                this.processando = false;
            });    
        } 
 
 
    }
